import React, {useState} from "react";
import {Box, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from "clsx";
import {useTranslation} from "react-i18next";

const formatterUSD = new Intl.NumberFormat('en-US', {
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
});

const useStyles = makeStyles((theme) => ({
    green: {
        color: "#47a447"
    },
    perksCollapsed: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        cursor: "pointer",
        gap: 4,
        "&:hover": {
            opacity: 0.8
        }
    },
    chevronIcon: {
        fontSize: "1rem",
        transition: "transform 0.2s",
    },
    chevronExpanded: {
        transform: "rotate(90deg)",
    },
    customTooltip: {
        "& .MuiTooltip-arrow": {
            left: "auto !important",
            right: "20px",
        }
    }
}));

function PerksDisplay({ cashEarned, cashEarnedAdditional }) {
    const classes = useStyles();
    const { t } = useTranslation("transactions");
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = (event) => {
        event.stopPropagation();
        setIsExpanded(prev => !prev);
    };

    // Show collapsible only when BOTH perks types exist
    if (cashEarned > 0 && cashEarnedAdditional > 0) {
        if (isExpanded) {
            // Expanded view - show both lines
            return (
                <>
                    <Typography
                        variant={"caption"}
                        className={classes.perksCollapsed}
                        onClick={toggleExpanded}
                    >
                        <ChevronRightIcon className={clsx(classes.chevronIcon, classes.chevronExpanded)} />
                        {t("perksEarned")}: <span className={classes.green}>${formatterUSD.format(cashEarned)}</span>
                    </Typography>
                    <Typography variant={"caption"} style={{paddingLeft: 20}}>
                        {t("additionalPerks")}: <span className={classes.green}>${formatterUSD.format(cashEarnedAdditional)}</span>
                    </Typography>
                </>
            );
        } else {
            // Collapsed view - show sum with tooltip
            return (
                <Tooltip
                    title={
                        <Box>
                            <div>{t("perksEarned")}: ${formatterUSD.format(cashEarned)}</div>
                            <div>{t("additionalPerks")}: ${formatterUSD.format(cashEarnedAdditional)}</div>
                        </Box>
                    }
                    arrow
                    placement="bottom-end"
                    classes={{ popper: classes.customTooltip }}
                >
                    <Typography
                        variant={"caption"}
                        className={classes.perksCollapsed}
                        onClick={toggleExpanded}
                    >
                        <ChevronRightIcon className={classes.chevronIcon} />
                        {t("perksEarned")}: <span className={classes.green}>${formatterUSD.format(cashEarned + cashEarnedAdditional)}</span>
                    </Typography>
                </Tooltip>
            );
        }
    }

    // Only one perk type - show simple lines without collapsible
    return (
        <>
            {cashEarned > 0 && (
                <Typography variant={"caption"}>
                    {t("perksEarned")}: <span className={classes.green}>${formatterUSD.format(cashEarned)}</span>
                </Typography>
            )}
            {cashEarnedAdditional > 0 && (
                <Typography variant={"caption"}>
                    {t("additionalPerks")}: <span className={classes.green}>${formatterUSD.format(cashEarnedAdditional)}</span>
                </Typography>
            )}
        </>
    );
}

export default PerksDisplay;



